export default {
  "phactmi_txt": "phactMI ",
  "podcast_txt": "Podcast Series",
  "welcome_txt": "Welcome to the phactMI Podcast",
  "eposide_txt": "Episode",
  "reference_txt": "References"
}
